<div class="loader-container" [class.loader-backdrop]="backdrop" *ngIf="isLoading">
  <div class="sk-wave sk-center">
    <div class="sk-wave-rect"></div>
    <div class="sk-wave-rect"></div>
    <div class="sk-wave-rect"></div>
    <div class="sk-wave-rect"></div>
    <div class="sk-wave-rect"></div>
  </div>
</div>
